import React from 'react';
import Modal from '../Modal.mjs';
import '../../css/ConfirmDialog.css';

const DangerIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
);

const InfoIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
);

/**
 * ConfirmDialog — themed replacement for window.confirm(). Usually invoked via
 * useConfirm() rather than rendered directly.
 */
const ConfirmDialog = ({
    title = 'Are you sure?',
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    danger = false,
    onConfirm,
    onCancel,
}) => (
    <Modal onClose={onCancel} className="qd-confirm" aria-labelledby="qd-confirm-title">
        <div className="qd-confirm-inner">
            <span className={`qd-confirm-icon ${danger ? 'qd-confirm-icon--danger' : 'qd-confirm-icon--default'}`} aria-hidden="true">
                {danger ? DangerIcon : InfoIcon}
            </span>
            <div className="qd-confirm-text">
                <h2 className="qd-confirm-title" id="qd-confirm-title">{title}</h2>
                {message && <p className="qd-confirm-message">{message}</p>}
            </div>
        </div>
        <div className="qd-confirm-actions">
            {/* fe-core-7: for a DESTRUCTIVE dialog, focus Cancel (the safe choice)
                so an immediate Enter doesn't trigger the danger action; otherwise
                focus the primary confirm. */}
            <button type="button" className="qd-btn qd-btn--secondary" onClick={onCancel} autoFocus={danger}>
                {cancelText}
            </button>
            <button
                type="button"
                className={`qd-btn ${danger ? 'qd-btn--danger' : 'qd-btn--primary'}`}
                onClick={onConfirm}
                autoFocus={!danger}
            >
                {confirmText}
            </button>
        </div>
    </Modal>
);

export default ConfirmDialog;
